let resizeTimer;

const indexBannerSlider = {
    selector: '.js-index-banner-slider',
    active: false,
    settings: {
        arrows: false,
        draggable: false,
        swipe: false,
        touchMove: false,
        autoplay: true,
        speed: 400,
        fade: true,
        asNavFor: '.js-index-banner-nav',
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    fade: false,
                    draggable: true,
                    swipe: true,
                    touchMove: true,
                    dots: true
                }
            }
        ]
    }
}

const indexBannerNavSlider = {
    selector: '.js-index-banner-nav',
    active: false,
    settings: {
        slidesToShow: 4,
        slidesToScroll: 1,
        vertical: true,
        arrows: false,
        draggable: false,
        swipe: false,
        touchMove: false,
        autoplay: false,
        speed: 400,
        focusOnSelect: true,
        asNavFor: '.js-index-banner-slider'
    },
    callbacks: {
        beforeChange: function(event, slick, currentSlide, nextSlide) {
            $('.js-index-banner-nav').find('.slick-slide').removeClass('is-last-visible');
        },
        afterChange: function(event, slick, currentSlide) {
            $('.js-index-banner-nav').find('.slick-active').last().addClass('is-last-visible');
            bLazy.revalidate();
        },
        setPosition: function(event, slick) {
        },
        init: function() {
            $('.js-index-banner-nav').find('.slick-active').last().addClass('is-last-visible');
            fixVerticalSliderHeight();
        }
    }
}

const indexCatalogSlider = {
    selector: '.js-index-catalogs-slider',
    active: false,
    arrowClass: 'index-catalogs__arrow',
    settings: {
        infinite: false,
        autoplay: true,
        dots: true,
        speed: 400,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    arrows: false
                }
            }
        ]
    }
}

const indexAboutSlider = {
    selector: '.js-index-about-slider',
    active: false,
    arrowClass: 'index-about__arrow',
    settings: {
        infinite: false,
        autoplay: true,
        speed: 400,
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    arrows: false,
                    dots: true
                }
            }
        ]
    }
}

const indexNewsSlider = {
    selector: '.js-index-news-slider',
    active: false,
    hasProducts: true,
    settings: {
        infinite: false,
        draggable: false,
        swipe: false,
        touchMove: false,
        autoplay: true,
        autoplaySpeed: 4000,
        speed: 400,
        nextArrow: $('.js-index-news-slider-arrow.is-next'),
        prevArrow: $('.js-index-news-slider-arrow.is-prev'),
        slidesToShow: 4,
        slidesToScroll: 4,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    draggable: true,
                    swipe: true,
                    touchMove: true,
                }
            }
        ]
    },
    callbacks: {
        breakpoint: function(event, slick, currentSlide) {
            Form.rebuildSpinners();
        }
    }
}

function sortOftenBought(sortBy) {
    const $items = $('.js-index-often-bought-item'),
        sort = sortBy.split(':');

    $items.sort(function (a, b) {
        const firstLetterA = $(a).data('first-letter'),
            firstLetterB = $(b).data('first-letter'),
            priceA = parseFloat( $(a).data('price') ),
            priceB = parseFloat( $(b).data('price') ),
            toEndA = $(a).hasClass('is-all') || $(a).hasClass('is-hidden'),
            toEndB = $(b).hasClass('is-all') || $(b).hasClass('is-hidden');

        let result;

        if (toEndA || toEndB) {
            if (toEndA) {
                result = 1;
            }

            if (toEndB) {
                result = -1;
            }
        } else {
            if (sort[0] == 'name') {
                if (sort[1] == 'd') {
                    result = firstLetterA < firstLetterB;
                } else {
                    result = firstLetterA > firstLetterB;
                }

                result = result ? 1 : -1;
            }
            else if (sort[0] == 'price') {
                if (sort[1] == 'd') {
                    result = priceB - priceA;
                } else {
                    result = priceA - priceB;
                }
            }
        }

        return result;
    });

    $('.js-index-often-bought').html($items);

    bLazy.revalidate();
    Form.rebuildSpinnersInside('.js-index-often-bought');
}

function oftenBoughtCategoryFilter(categoryId) {
    let $items = $('.js-index-often-bought-item');

    if (categoryId == 0) {
        $items.removeClass('is-hidden');
    } else {
        $('.js-index-often-bought-item').each(function() {
            if ($(this).hasClass('is-all') || categoryId == $(this).data('category-id')) {
                $(this).removeClass('is-hidden');
            } else {
                $(this).addClass('is-hidden');
            }
        });
    }

    $('.js-index-often-bought').removeClass('is-collapsed');

    sortOftenBought($('.js-index-often-bought-sort').val());
}

function fixVerticalSliderHeight() {
    if (indexBannerNavSlider.active) {
        const $items = $('.js-index-banner-nav').find('.js-index-banner-nav-item'),
            navHeight = $('.js-index-banner-nav').height(),
            slideHeight = Math.round(navHeight / 4);

        $items.each(function() {
            $(this).height(slideHeight);
        });

        $('.js-index-banner-nav').slick('setPosition');
    }
}

$(function() {
    initSlickSlider(indexBannerSlider);
    initSlickSlider(indexBannerNavSlider);
    initSlickSlider(indexCatalogSlider);
    initSlickSlider(indexAboutSlider);
    initSlickSlider(indexNewsSlider);

    fixVerticalSliderHeight();

    $('.js-index-login-form').validate({
        submitHandler: function(form) {
            Form.ajaxPost(form, function(data) {
                var $loginMessage = $('.js-index-login-message');

                $loginMessage.hide().removeClass('c-msg--error c-msg--success');

                if (!data.status) {
                    $loginMessage
                        .text(data.message)
                        .addClass('c-msg--error')
                        .slideDown();
                } else {
                    $loginMessage
                        .text(data.message)
                        .addClass('c-msg--success')
                        .slideDown();

                    $('.js-index-login-hide').slideUp(250, function() {
                        location.reload();
                    });
                }
            }, 'json');
        }
    });

    $('.js-index-news-slider-select').on('change', function() {
        let $this = $(this),
            filteredCategory = $this.val(),
            filteredClass = 'div.js-index-news-item-' + filteredCategory,
            $slider = $(indexNewsSlider.selector);

        $slider.slick('slickUnfilter');

        if ($this.val() != 0) {
            $slider.slick('slickFilter', function(index, element) {
                return $(element).find(filteredClass).length;
            });
        }

        $slider.slick('slickGoTo', 0);
    });

    $('.js-index-often-bought-sort').on('change', function() {
        sortOftenBought($(this).val());
    });

    $('.js-index-often-bought-category').on('change', function() {
        oftenBoughtCategoryFilter($(this).val());
    });

    $(document).on('click', '.js-index-often-bought-all', function (e) {
        e.preventDefault();

        $('.js-index-often-bought').removeClass('is-collapsed');
    })

    $('.js-index-wishlist-info-close').on('click', function(e) {
        e.preventDefault();

        $('.js-index-wishlist-info').slideUp();

        setCookie('wishlistIndexInfoMessage', true, 14);
    });

    $('.js-index-categories-all').on('click', function(e) {
        e.preventDefault();
        e.stopPropagation();

        if (checkMedia('cxs,xs')) {
            toggleAsideNav(true);
        } else {
            $('html, body').animate({
                scrollTop: 0
            }, 150);

            showElem(navigation);
        }
    });

    $(window).on('resize', function(e) {
        $('.slick-list').height($('.js-index-banner-nav').height());

        clearTimeout(resizeTimer);

        resizeTimer = setTimeout(function() {
            fixVerticalSliderHeight();
        }, 250);
    });
});